(() => {
  function reveal(event) {
    if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
    const card = event.target.closest?.('.m-product-card');
    const template = card?.querySelector('template[data-eaura-hover-image]');
    if (!template) return;
    const content = template.content.cloneNode(true);
    const image = content.querySelector('img');
    if (!image) return;
    image.loading = 'eager';
    image.addEventListener('load', () => {
      card.classList.add('m-product-card--show-second-img');
    }, { once: true });
    template.replaceWith(content);
    if (image.complete && image.naturalWidth) {
      card.classList.add('m-product-card--show-second-img');
    }
  }
  document.addEventListener('pointerover', reveal);
  document.addEventListener('focusin', reveal);
})();
